import React, { Component } from 'react'
import { Button, Icon } from 'antd'
import Head from '../../components/head'
import businessQuitTime from '../../utils/businessQuitTime'
import { connect } from 'react-redux'
import * as Action from '@/store/actions/createCard'
import './index.scss'
import tempCard from '../../assets/img/tempCard.png'

/*
 * 确认身份证信息
 */
class HealthConfirmIdCard extends Component {
  constructor(props){
    super(props)
    this.state = {
      cardInfo: {}
    };

    this.jumpWritePhone = this.jumpWritePhone.bind(this)
    this.goUpPage = this.goUpPage.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
  }

  goHomePage(){
    this.props.history.push('/')
  }
  goUpPage(){
    this.props.history.push('/healthCard')
  }

  jumpWritePhone(){
    this.props.history.push('/healthInsertPhone')
  }

  componentDidMount(){
    this.setState({
      cardInfo: this.props.createCard.createCard
    })
  }

  render() {
    const { cardInfo } = this.state;

    return (
      <div>
        <Head quitTime={businessQuitTime.createArchives.confirmIdCard} />
        <div className="context-container clearfix">
          <h2 className="crumbs">注册电子健康卡 - 请确认你的身份信息</h2>
          <div className="con-card">
            <div className="idcard-con">
              <div className="idcard-name pos-a">{ cardInfo.NAME }</div>
              <div className="idcard-sex pos-a">{ cardInfo.SEX }</div>
              <div className="idcard-peopleNation pos-a">{ cardInfo.PEOPLENATION }</div>
              <div className="idCard-birthday pos-a">{ cardInfo.BIRTHDAY }</div>
              <div className="idcard-address pos-a">{ cardInfo.ADDRESS }</div>
              <div className="idcard-card pos-a">{ cardInfo.NUMBER }</div>
              <div className="idCard-img">
                <img src={tempCard} alt=""/>
              </div>
            </div>
            <em>
              <Button type="primary" size="large" onClick={ this.jumpWritePhone } style={{backgroundColor: "#00bd58", border: "1px #00bd58 solid"}}>确 定</Button>
            </em>
          </div>
        </div>
        <div className="footer">
          <Button type="primary" size="large" onClick={ this.goUpPage } className="left">
            <Icon type="left" />上一步</Button>
          <Button type="primary" size="large" onClick={ this.goHomePage }
            style={{ "backgroundColor": "#f76e6e", border: "1px #f76e6e solid", "float": "right"}}>
            <Icon type="poweroff" theme="outlined" />退 出</Button>
          <div className="address"></div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    createCard: state
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addCardData: (data) => {
      dispatch(Action.addCardData(data));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthConfirmIdCard);